export class PrimeiroAcessoRequest {
  email: string;
  senhaAntiga: string;
  senha1: string;
  senha2: string;
}
